import { subscribeToPinnedObjectLoading } from "./pinned-object-progress";

const MB = 1024 * 1024;

function formatBytes(bytes) {
  return `${(bytes / MB).toFixed(1)}MB`;
}

// Console-only probe used to validate the glTF download instrumentation before wiring any UI to it.
export function logModelProgressToConsole(el, label) {
  let lastKey = "";

  const onProgress = ({ detail }) => {
    const { bytesLoaded, bytesTotal, itemsLoaded, itemsTotal } = detail;
    const percent = bytesTotal ? Math.floor((bytesLoaded / bytesTotal) * 100) : null;
    const key = `${percent}/${itemsLoaded}/${itemsTotal}`;
    if (key === lastKey) return;
    lastKey = key;

    const bytes =
      percent === null
        ? `${formatBytes(bytesLoaded)} (size unknown)`
        : `${percent}% (${formatBytes(bytesLoaded)}/${formatBytes(bytesTotal)})`;
    console.log(`[loading] ${label}: ${bytes}, items ${itemsLoaded}/${itemsTotal}`);
  };

  const onDone = () => {
    el.removeEventListener("model-progress", onProgress);
    console.log(`[loading] ${label}: done`);
  };

  el.addEventListener("model-progress", onProgress);
  el.addEventListener("model-loaded", onDone, { once: true });
  el.addEventListener("model-error", onDone, { once: true });
}

export function logPinnedObjectLoadingToConsole() {
  subscribeToPinnedObjectLoading(({ loadedCount, total, percent }) => {
    console.log(`[loading] pinned object media: ${loadedCount}/${total} (${percent}%)`);
  });
}
